import type { CityConfig } from "../city-template/types";

export const muncieConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Muncie",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "muncie",
  route: "/cities/muncie",
  title: "Emergency Passport Muncie, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Muncie, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Muncie, Yorktown, Anderson, and all Delaware County residents. A+ BBB rated courier service serving Ball State University students and faculty.",
  h1: "Emergency & Expedited Passport Services in Muncie, IN",
  heroSubtitle: "Muncie travelers — from Ball State University students and faculty heading abroad to Delaware County families planning international vacations to business professionals in East Central Indiana — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, about 90 minutes southwest via I-69.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Muncie%20Indiana%20university%20town%20with%20Ball%20State%20University%20campus%20featuring%20iconic%20Beneficence%20statue%20and%20red%20brick%20academic%20buildings%2C%20East%20Central%20Indiana%20college%20town%20with%20tree%20lined%20streets%20and%20vibrant%20student%20community%2C%20autumn%20colors%20on%20campus%20quad%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%20with%20rich%20warm%20tones%2C%20classic%20Midwestern%20college%20town%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=muncie-in-hero-001&orientation=landscape",
  heroImageAlt: "Muncie Indiana with Ball State University campus and Beneficence statue",
  geoPosition: "40.1934;-85.3864",
  geoPlacename: "Muncie, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 200 miles, 3.5 hours via I-69 and I-65",
  },
  nearbyCitiesZips: [
    { name: "Muncie", zips: "47302, 47303, 47304, 47305, 47306" },
    { name: "Yorktown", zips: "47396" },
    { name: "Anderson", zips: "46011, 46012, 46013, 46016, 46017" },
    { name: "Selma", zips: "47383" },
    { name: "Albany", zips: "47320" },
    { name: "Daleville", zips: "47334" },
    { name: "New Castle", zips: "47362" },
    { name: "Marion", zips: "46952, 46953" },
    { name: "Hartford City", zips: "47348" },
    { name: "Winchester", zips: "47394" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — about 3.5 hours from Muncie via I-69/I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Ball State and Delaware County" },
    { icon: "ri-building-line", title: "Ball State University Hub", desc: "Serving BSU students, faculty, staff, and Delaware County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx near campus or downtown Muncie" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Urgent passport services in Anderson, IN", route: "/anderson" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Muncie, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 200 miles — about 3.5 hours via I-69 and I-65. We handle the drive so Muncie residents, Ball State students, and Delaware County families never need to make the trip to Chicago themselves.",
  fpcOfficeDistance: "Serving Muncie, Yorktown, Anderson, Selma, Albany, Daleville, New Castle, Marion, Hartford City, and all of Delaware County and East Central Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Muncie and Delaware County. From the Ball State University campus and the Village business district to Yorktown, Anderson, and surrounding East Central Indiana communities — we serve the entire region with courier access to the Chicago Passport Agency.",
  nearbyCitiesIntro: "We serve Muncie and all nearby communities including Yorktown, Anderson, Selma, Albany, Daleville, New Castle, Marion, Hartford City, and Winchester. We also serve all of Delaware County, Madison County, and the East Central Indiana region.",
  howItWorksIntro: "Most Muncie travelers — especially Ball State students and faculty — complete everything online and ship documents via overnight courier from any UPS or FedEx near campus or downtown Muncie. Our registered couriers handle the Chicago Passport Agency delivery so you can focus on your travel plans.",
  mistakesIntro: "Muncie is home to Ball State University with thousands of students, faculty, and researchers traveling internationally every year. Here are the most common passport mistakes we see from Delaware County and BSU travelers.",
  testimonialsIntro: "Muncie travelers — from Ball State students studying abroad to Delaware County families to business professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Muncie, IN? Here are the most common ones we hear from BSU and Delaware County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Muncie", "Perfect for BSU study abroad, faculty research, and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned study abroad and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~3.5 hours each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Muncie travelers with immediate departure needs — as fast as 24 hours. Ideal for BSU students with unexpected study abroad deadlines or last-minute international travel emergencies.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 3.5-hour drive", "BSU student and faculty travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Muncie adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for BSU faculty and Delaware County professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Muncie address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for BSU students, Delaware County residents, and new citizens in the Muncie area.",
      bullets: ["Acceptance facility scheduling near campus", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Muncie residents — whether lost on campus, during a move, or while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Muncie and Delaware County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Muncie and Delaware County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Muncie IN", description: "Urgent passport processing for Muncie Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Muncie IN", description: "Fast passport renewal for Muncie Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Muncie IN", description: "New passport application services for Muncie Indiana residents and Ball State University students." },
    { name: "Child Passport Muncie IN", description: "Minor passport services for Muncie Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jessica R.",
      location: "Muncie, IN — Ball State Campus",
      rating: 5,
      text: "Study abroad semester in London starting in 10 days — realized my passport was expired. Fast Passport Center got me renewed in 3 days. Shipped from the UPS Store near campus and everything worked out. Lifesaver for BSU students!",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Dr. Michael T.",
      location: "Muncie, IN — Near Minnetrista",
      rating: 5,
      text: "Research collaboration in Seoul with 8 days notice. My passport had less than 4 months validity. Fast Passport Center expedited a renewal — had it back in 4 days. Outstanding service for academic professionals.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Amanda S.",
      location: "Yorktown, IN",
      rating: 5,
      text: "Family trip to Ireland and my two teenagers needed first-time passports. The Muncie Post Office was booked for weeks. Fast Passport Center handled all three applications in 5 days. Incredible service for Delaware County families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Chris D.",
      location: "Muncie, IN — Downtown",
      rating: 5,
      text: "Lost my passport during a move between apartments near the Village. Had a flight to Tokyo in 6 days booked months ago. Fast Passport Center replaced it in 48 hours. The courier to Indianapolis saved me a 3-hour round trip.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "muncie-in-1",
      name: "Muncie Post Office — Main",
      type: "USPS Passport Acceptance Facility",
      address: "501 W Memorial Dr",
      city: "Muncie",
      state: "IN",
      zip: "47302",
      phone: "(765) 282-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Muncie, near downtown and the White River",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Muncie acceptance facility. Appointments required — book 2–3 weeks ahead during BSU academic year. Extremely busy during study abroad application season (September–October and February–March).",
      icon: "ri-mail-line",
    },
    {
      id: "muncie-in-2",
      name: "Delaware County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "100 W Main St",
      city: "Muncie",
      state: "IN",
      zip: "47305",
      phone: "(765) 747-7726",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Downtown Muncie, Delaware County Building",
      website: "https://www.co.delaware.in.us/",
      websiteLabel: "Delaware County",
      notes: "County clerk passport acceptance at the Delaware County Building. Extended morning hours (opens at 8:30AM). Good alternative when post office appointments are full during peak BSU travel seasons.",
      icon: "ri-government-line",
    },
    {
      id: "muncie-in-3",
      name: "Anderson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2105 E 5th St",
      city: "Anderson",
      state: "IN",
      zip: "46012",
      phone: "(765) 644-7638",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 20 miles southwest of Muncie, in Anderson",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Madison County acceptance facility serving Anderson. Convenient for southwestern Delaware County residents. Often has better appointment availability than Muncie during peak travel seasons.",
      icon: "ri-mail-line",
    },
    {
      id: "muncie-in-4",
      name: "New Castle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "305 S 14th St",
      city: "New Castle",
      state: "IN",
      zip: "47362",
      phone: "(765) 529-3600",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 15 miles south of Muncie, in New Castle",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Henry County facility serving New Castle and southern Delaware County. Smaller post office — good alternative when Muncie appointments are full.",
      icon: "ri-mail-line",
    },
    {
      id: "muncie-in-5",
      name: "Marion Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 W 3rd St",
      city: "Marion",
      state: "IN",
      zip: "46952",
      phone: "(765) 664-4512",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 25 miles north of Muncie, in Marion",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Grant County acceptance facility. Convenient for northern Delaware County and Hartford City residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 200-mile, 3.5-hour drive to Chicago via I-69/I-65", fpc: "No — ship from Muncie, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "BSU Study Abroad", agency: "No special support for students", fpc: "Experienced with BSU study abroad deadlines" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "BSU students often discover passport issues right before study abroad deadlines. Routine processing takes 8–11 weeks. Spring and fall study abroad seasons see massive demand at the Muncie Post Office — start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Student photo services near BSU campus sometimes produce photos that fail passport standards. Photos must be exactly 2x2 inches on a white background — no filters, no smiling with teeth showing, no glasses. Even the slightest deviation results in rejection.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants — especially BSU students applying for their first passport — often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 can be mailed for most renewals by adults who already hold a passport.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for BSU Academic Calendar",
      description: "Study abroad deadlines typically fall in March (for fall programs) and October (for spring programs). Muncie Post Office appointments fill 3–4 weeks in advance during these periods. Plan passport applications around the academic calendar, not just your travel date.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries — especially across Europe and Asia — require 6 months of passport validity beyond your planned stay. BSU students heading to semester-long programs abroad often discover this requirement too late, just weeks before departure.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming the Chicago Agency Is Easy to Reach",
      description: "The Chicago Passport Agency is about 200 miles from Muncie via I-69 and I-65 — a 3.5-hour drive each way. Appointments must be booked through NPIC and are not guaranteed. A 7-hour round trip for a 15-minute appointment is not practical for most BSU students with class schedules. Fast Passport Center's courier handles it all.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Muncie or on the BSU campus." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at the UPS Store near campus or any FedEx in Muncie." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for BSU or Delaware County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 3.5-hour drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Muncie address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Muncie, IN?", a: "Fast Passport Center offers emergency passport processing in Muncie, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — no need to make the 3.5-hour drive yourself." },
    { q: "Does Muncie have its own passport agency?", a: "No — Muncie does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 200 miles away (about a 3.5-hour drive via I-69 and I-65). Fast Passport Center's courier service means Muncie residents and BSU students never need to make the trip to Chicago themselves." },
    { q: "Can BSU international students get passport help in Muncie?", a: "Fast Passport Center specializes in U.S. passport services for U.S. citizens. International students should contact their home country's embassy or consulate for passport services. We can help BSU faculty, staff, and U.S. citizen students with American passport needs." },
    { q: "What airport do Muncie travelers use?", a: "Indianapolis International Airport (IND) is the primary international airport for Muncie travelers, located about 70 miles southwest (approximately 75 minutes via I-69). IND offers direct flights to Toronto, Cancun, and Paris (seasonal), plus connecting service worldwide through major hubs. Fort Wayne International (FWA) is about 75 minutes north as an alternative." },
    { q: "How much does an expedited passport cost in Muncie?", a: "Government fees are fixed: $130 for a first-time adult passport or $130 + $60 expedite fee for a renewed adult passport book. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Muncie?", a: "Walgreens (1400 W McGalliard Rd and 1501 E 29th St), CVS (3310 N Everbrook Ln), and the UPS Store (600 E McGalliard Rd) all offer passport photos in Muncie. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve BSU faculty traveling for research?", a: "Yes. We serve all Ball State University faculty, staff, and researchers in Muncie. We understand academic travel deadlines — conferences, research collaborations, and field work — and can coordinate expedited services to match your specific travel schedule." },
    { q: "What about Yorktown, Anderson, or New Castle residents?", a: "Absolutely. Fast Passport Center serves all of Delaware County and surrounding areas including Yorktown, Anderson, Selma, Albany, Daleville, New Castle, Marion, and Hartford City. Our courier service works the same way for everyone throughout East Central Indiana." },
  ],
  photoLocations: [
    { name: "Walgreens — Muncie (McGalliard)", address: "1400 W McGalliard Rd, Muncie, IN 47304", hours: "Mon–Sun: 7AM–10PM" },
    { name: "CVS — Muncie", address: "3310 N Everbrook Ln, Muncie, IN 47304", hours: "Mon–Sun: 8AM–9PM" },
    { name: "UPS Store — Muncie (McGalliard)", address: "600 E McGalliard Rd, Muncie, IN 47303", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walgreens — Muncie (29th St)", address: "1501 E 29th St, Muncie, IN 47302", hours: "Mon–Sun: 7AM–10PM" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Muncie", address: "3631 N Everbrook Ln, Muncie, IN 47304", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Delaware County BMV branch on Everbrook Lane. Driver's licenses and REAL ID processing. Online reservations strongly recommended — this is the primary branch for Muncie and Delaware County residents.", featured: true },
    { name: "Indiana BMV — Anderson", address: "2915 Enterprise Dr, Anderson, IN 46013", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Anderson and Madison County. Alternative when Muncie BMV appointments are full. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "70 miles southwest of Muncie via I-69 — approximately 75 minutes",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Muncie and Delaware County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. The main hub for BSU international travelers and East Central Indiana residents.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "FWA",
      name: "Fort Wayne International Airport",
      distance: "75 miles north of Muncie via I-69 — approximately 75 minutes",
      address: "3801 W Ferguson Rd, Fort Wayne, IN 46809",
      note: "Alternative airport for Muncie travelers in northern Delaware County. Domestic connections to major hubs. Good option when IND routes are limited or for northeastern Indiana destinations.",
      flightUrl: "https://fwairport.com/",
      flightLabel: "FWA Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Delaware County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Delaware County and all Indiana counties" },
    { label: "Delaware County Clerk: Marriage Licenses", url: "https://www.co.delaware.in.us/", icon: "ri-heart-line", description: "Delaware County Clerk — marriage license records for Muncie and Delaware County" },
    { label: "Delaware County: Divorce Decrees", url: "https://www.co.delaware.in.us/", icon: "ri-file-list-3-line", description: "Delaware County Clerk of Courts — divorce decree records for Muncie and Delaware County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Muncie address" },
  ],
};